import BaseResource from './BaseResource'

export default class ItemTypes extends BaseResource {
  static endpoint = '/api/v1/itemTypes' ///tracking
}
